import React from 'react'

export default () => (
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.984596 18.7656C0.594071 18.3751 0.594071 17.7419 0.984596 17.3514L15.8945 2.44149L5.58079 2.44149C5.0285 2.44149 4.58079 1.99378 4.58079 1.44149C4.58079 0.889209 5.0285 0.441493 5.58079 0.441493L18.3087 0.441493C18.861 0.441493 19.3087 0.889208 19.3087 1.44149L19.3087 14.1694C19.3087 14.7217 18.861 15.1694 18.3087 15.1694C17.7564 15.1694 17.3087 14.7217 17.3087 14.1694L17.3087 3.85571L2.39881 18.7656C2.00829 19.1561 1.37512 19.1561 0.984596 18.7656Z" fill="currentColor"/>
  </svg>

)
